import { message } from "antd";
import axios from "axios";

import { getItem } from "../../utils/localStorageControl";
// const API_ENDPOINT = "https://staging-api.xpofairs.com/api/v1";
const API_ENDPOINT = "https://api.xpofairs.com/api/v1";
// const API_ENDPOINT = "https://35.176.158.190/api/v1";

const authHeader = () => ({
  Authorization: `Bearer ${getItem("access_token")}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${getItem("access_token")}`,
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    // "ngrok-skip-browser-warning": true,
  },
});

class DataService {
  static get(path = "", message = {}) {
    return client({
      method: "GET",
      url: path,
      message: {},
      headers: { ...authHeader() },
    });
  }

  static post(path = "", data = {}, progressCallback) {
    return client({
      method: "POST",
      url: path,
      data: data,
      headers: { ...authHeader() },
      onUploadProgress: (data) => {
        let percentage = Math.round((data.loaded * 100) / data.total);
        if (progressCallback) {
          progressCallback(percentage);
        }
      },
    });
  }

  static patch(path = "", data = {}) {
    return client({
      method: "PATCH",
      url: path,
      data: data,
      headers: { ...authHeader() },
    });
  }

  static put(path = "", data = {}, progressCallback) {
    return client({
      method: "PUT",
      url: path,
      data,
      headers: { ...authHeader() },
      onUploadProgress: (data) => {
        let percentage = Math.round((data.loaded * 100) / data.total);
        if (progressCallback) {
          progressCallback(percentage);
        }
      },
    });
  }

  static delete(path = "") {
    return client({
      method: "DELETE",
      url: path,
      headers: { ...authHeader() },
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use((config) => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = {
    ...headers,
    Authorization: `Bearer ${getItem("access_token")}`,
  };

  return requestConfig;
});

client.interceptors.response.use(
  (response) => {
    if (response.data.data && Array.isArray(response.data.data)) {
      // Hide Success messages on list api
      // n.close();
      // typeof yourVariable === "object";
    } else if (response.config.method === "get") {
    } else {
      message.success({
        content: response.data.message,
        style: {
          float: "center",
          marginTop: "2vh",
        },
      });
    }
    return response;
  },
  (error) => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    // const originalRequest = error.config;
    if (response) {
      // if (response.status === 500) {
      //   // To Do
      // } else if (response.status === 400) {
      //   message.error({
      //     content: response.data.message,
      //     style: {
      //       float: "center",
      //       marginTop: "2vh",
      //     },
      //   });
      // } else if (response.status === 403) {
      //   message.error({
      //     content: response.data.message,
      //     style: {
      //       float: "center",
      //       marginTop: "2vh",
      //     },
      //   });
      // } else if (response.status === 404) {
      //   message.error({
      //     content: response.data.message,
      //     style: {
      //       float: "center",
      //       marginTop: "2vh",
      //     },
      //   });
      // }
      // else if (response.status === 422) {
      //   message.error({
      //     content: response.data.message,
      //     style: {
      //       float: "center",
      //       marginTop: "2vh",
      //     },
      //   });
      // }
      // else if (response.status === 401) {
      //   message.error({
      //     content: response.data.message,
      //     style: {
      //       float: "center",
      //       marginTop: "2vh",
      //     },
      //   });
      // } else {
      //   return originalRequest;
      // }
      if (response.data.messageCode === "EMAIL_NOT_AVAILABLE") {
        return response.data;
      }
      message.error({
        content: response.data.message,
        style: {
          float: "center",
          marginTop: "2vh",
        },
      });
      return response.data;
    } else {
      message.error({
        content: `Something went wrong. Please check your internet connection and try again!`,
        style: {
          float: "center",
          marginTop: "2vh",
        },
      });
    }
    return Promise.reject(error);
  }
);
export { DataService };
